import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";

import "./tourinclusion.scss";

function TourInclusionList() {
  const navigate = useNavigate();
  const [tourInclusions, setTourInclusions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const breadcrumbItems = [
    { title: "Tour Inclusion", link: "#" },
    { title: "Tour Inclusion List", link: "#" },
  ];

  React.useEffect(() => {
    fetchTourInclusion();
  }, []);

  const fetchTourInclusion = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/tourinclusions`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Tour Inclusion data:', data);
      
      // Handle different response formats
      if (Array.isArray(data)) {
        setTourInclusions(data);
      } else if (data.data && Array.isArray(data.data)) {
        setTourInclusions(data.data);
      } else if (Array.isArray(data.tourInclusions)) {
        setTourInclusions(data.tourInclusions);
      } else {
        console.warn('Unexpected data format:', data);
        setTourInclusions([]); // Set to empty array if format is unexpected
      }
    } catch (error) {
      console.error('Error fetching tourinclusions:', error);
      setError(error.message);
      setTourInclusions([]); // Ensure it's always an array
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (tourinclusion) => {
    navigate(`/edit-tourinclusions/${tourinclusion._id}`, { state: { tourinclusion } });
  };

  const handleDelete = async (tourinclusionId) => {
    if (window.confirm("Are you sure you want to delete this tour inclusion?")) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/tourinclusions/${tourinclusionId}`, {
          method: 'DELETE'
        });
        
        if (response.ok) {
          setTourInclusions(tourInclusions.filter(cat => cat._id !== tourinclusionId));
        } else {
          console.error('Failed to delete tour inclusion');
        }
      } catch (error) {
        console.error('Error deleting tour inclusion:', error);
      }
    }
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center">Loading tour inclusions...</div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center text-danger">Error: {error}</div>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Tour Inclusion List"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-4">
                    <Link to="/create-tourinclusions">
                      <Button color="primary">
                        <i className="ri-add-line align-middle me-1"></i> Add Tour Inclusion
                      </Button>
                    </Link>
                  </div>
                  <div className="table-responsive">
                    <Table className="table table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Tour Inclusion Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tourInclusions.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="text-center">
                              No tour inclusions found.
                            </td>
                          </tr>
                        ) : (
                          tourInclusions.map((tourinclusion, index) => (
                            <tr key={tourinclusion._id || index}>
                              <td>{tourinclusion._id}</td>
                              <td>{tourinclusion.tourinclusion_name || 'N/A'}</td>
                              <td>
                                <button 
                                  className="tour-action-buttons me-2"
                                  onClick={() => handleEdit(tourinclusion)}
                                >
                                  <i className="ri-pencil-fill"></i>
                                </button>
                                <button 
                                  className="tour-action-buttons text-danger"
                                  onClick={() => handleDelete(tourinclusion._id)}
                                >
                                  <i className="ri-delete-bin-fill"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default TourInclusionList;